import React from 'react';
import { IconProps } from './types';

export const GlobeIcon = (props: IconProps) => {
  const { size = 16, color = 'currentColor', style = {} } = props;

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
    >
      <path
        fill={color}
        d='M22.9 11C22.4 5.4 17.7 1 12 1S1.6 5.4 1.1 11H1v2h.1c.5 5.6 5.2 10 10.9 10s10.4-4.4 10.9-10h.1l-.1-2zm-2 0h-4c-.2-2.8-1.1-5.4-2.7-7.7 3.6.9 6.3 4 6.7 7.7zM9.1 13H15c-.3 2.7-1.3 5.3-2.9 7.4-1.8-2.1-2.8-4.7-3-7.4zm0-2c.3-2.7 1.3-5.3 2.9-7.4 1.7 2.2 2.7 4.8 2.9 7.4H9.1zm.6-7.7C8.2 5.6 7.3 8.2 7.1 11h-4c.4-3.7 3.1-6.8 6.6-7.7zM3.1 13h4c.2 2.8 1.1 5.4 2.7 7.7-3.6-.9-6.3-4-6.7-7.7zm11.2 7.7c1.5-2.3 2.4-4.9 2.7-7.7h4c-.5 3.7-3.2 6.8-6.7 7.7z'
      />
    </svg>
  );
};
